<template>
  <input
      type="email"
      :id="id"
      :value="value"
      @input="emitValue"
      @focusout="trimValue"
      :placeholder="placeholder"
      :class="{'tw-border-error': hasError}"
      class="border-1 border-solid w-full p-2.5 leading-6 border-border rounded-6 shadow-none outline-none focus:border-signableSecondary2Shade3 focus:shadow-input"
  />
</template>

<script>
export default {
  name: 'EmailInput',
  props: {
    value: {
      type: String,
    },
    id: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitValue(event) {
      const { value } = event.target;
      this.$emit('input', value.trim());
    },
    trimValue(event) {
      const { input } = event.target;
      input.value = this.value.trim();
    },
  },
};
</script>
